export default __webpack_public_path__ + "static/media/injectables.d01c6bf1.jpg";